import type { i18n } from 'i18next'
import { LANGUAGE_STORAGE_KEY, createI18n, resolveLanguage } from '@dorixona/i18n'
import { setDisplayLanguage } from '@dorixona/utils'
import { telegramLanguage } from './telegram'

/** Language order: the user's own choice → Telegram → browser → RU. */
export function createAppI18n(
  storage: Pick<Storage, 'getItem'> = localStorage,
  navigatorLanguage: string = navigator.language,
): i18n {
  const language = resolveLanguage([
    storage.getItem(LANGUAGE_STORAGE_KEY),
    telegramLanguage(),
    navigatorLanguage,
  ])
  const instance = createI18n({ language })
  followLanguage(instance)
  return instance
}

/**
 * Вслед за языком интерфейса переключаются даты и валюта (`@dorixona/utils`),
 * заголовок `X-Lang` у запросов (он читает тот же язык) и `lang` страницы —
 * по нему читалка экрана выбирает произношение.
 */
export function followLanguage(instance: i18n): void {
  const apply = (next: string) => {
    const language = resolveLanguage([next])
    setDisplayLanguage(language)
    document.documentElement.lang = language
  }
  apply(instance.language)
  instance.on('languageChanged', apply)
}
